import type { SxProps } from "@mui/material"

import { DOT_PASSIVE, PRIMARY } from "../../../../constants/colors"

const container: SxProps = {
  width: "90%",
  justifyContent: "center",
  alignItems: "center"
}

const dotListContainer: SxProps = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center"
}

const dot: SxProps = {
  width: "0.5rem",
  aspectRatio: 1,
  borderRadius: 100,
  background: DOT_PASSIVE
}

const dotActive: SxProps = {
  width: "0.75rem",
  aspectRatio: 1,
  borderRadius: 100,
  background: PRIMARY
}

export default { container, dotListContainer, dot, dotActive }
